module.exports = __webpack_public_path__ + "static/media/trianglify.5229a3d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/trianglify.png
// module id = 5831
// module chunks = 0